// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  DefaultUrlSerializer,
  UrlTree,
} from '@angular/router';

const redirectKey = 'redirect';

const urlSerializer = new DefaultUrlSerializer();

//jan: all of this stuff probably should go..
@Injectable()
export class ParameterController {
  public storeRoute(urlTree: UrlTree): void {
    sessionStorage.setItem(redirectKey, urlSerializer.serialize(urlTree));
  }

  public unstoreRoute(): UrlTree | null {
    const storedRoute = sessionStorage.getItem(redirectKey);
    sessionStorage.removeItem(redirectKey);

    if (!storedRoute) {
      return null;
    }

    return urlSerializer.parse(storedRoute);
  }

  public systemPassedByQueryParams(route: ActivatedRouteSnapshot):
    | {
        systemMaterialNumber: number;
        systemSerialNumber: string;
        ticketNumber: string;
      }
    | undefined {
    const queryParams = route.queryParams;
    if (
      queryParams['systemserialnumber'] !== undefined &&
      queryParams['systemmaterialnumber'] !== undefined &&
      queryParams['ticketnumber'] !== undefined
    ) {
      return {
        systemMaterialNumber: parseInt(queryParams['systemmaterialnumber']),
        systemSerialNumber: queryParams['systemserialnumber'],
        ticketNumber: queryParams['ticketnumber'],
      };
    } else {
      return undefined;
    }
  }
}
